module.exports = __webpack_public_path__ + "img/logoLorfolio.b0af82af.svg";